import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	avatar: {
		flexShrink: 0,
		height: 32,
		width: 32,
	},
	email: {
		...THEME.common.truncate,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	item: {
		gap: SPACE[12],
	},
	name: {
		...THEME.common.truncate,
	},
	// Wider than a narrow input so emails, which often differ only at the end, stay readable.
	popup: {
		maxWidth: 'var(--available-width)',
		minWidth: 'var(--anchor-width)',
		width: 'max-content',
	},
	text: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		minWidth: 0,
	},
});
